export default [
    {
        path: 'jornada',
        component: () => import(
            /* webpackChunkName: 'exame-imagem-jornada' */
            '@/views/exame-imagem/jornada/Index'
        ),
        redirect: 'jornada/index',
        children: [
            {
                name: 'exame-imagem-jornada-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'exame-imagem-jornada' */
                    '@/views/exame-imagem/jornada/List.vue'
                ),
            },
            {
                name: 'exame-imagem-jornada-create',
                path: 'create/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'exame-imagem-jornada' */
                    '@/views/exame-imagem/jornada/Form.vue'
                ),
            },
        ],
    },
]